import setWith from 'lodash/setWith'
import i18n from 'i18next'

export default (errors = undefined, valuePrefixKey = '') => {
  if (!errors) {
    return { fields: {} }
  }

  let extractedErrors = { hash: null, form: null, fields: {} }

  if (Array.isArray(errors) && errors.length > 0) {
    const formError =
      errors.length === 1 && typeof errors[0] === 'string'
        ? {
            [errors[0].match(/\(([a-z0-9])+\)/) ? 'hash' : 'form']: errors[0]
              .length
              ? errors[0]
              : 'common::notifications.try_again_later',
          }
        : errors.find((error) => {
            const [path] = Object.entries(error)[0]
            return path === 'form'
          })

    if (formError) {
      extractedErrors = { ...extractedErrors, ...formError }
    }

    extractedErrors.fields = errors
      .filter((error) => typeof error !== 'string')
      .reduce((acc, error) => {
        const [path, message] = Object.entries(error)[0]

        if (path !== 'form') {
          // Проверям, что фраза для перевода ошибки это ключ или готовая переведенная фраза по регексп

          const phraseToTranslate =
            (new RegExp(/^([A-Z_0-9]*)$/g).test(message)
              ? valuePrefixKey
              : '') + message

          acc = setWith(acc, path, i18n.t(phraseToTranslate))
        }

        return acc
      }, {})

    return extractedErrors
  } else {
    return {
      hash: null,
      form: 'common::notifications.try_again_later',
      fields: {},
    }
  }
}
